import instance from './instance';
import { Oked } from '../models';

export interface GetCategoriesParams
  extends Partial<Pick<Oked, 'parentNumber'>> {}

export function getCategories(params: GetCategoriesParams): Promise<Oked[]> {
  return instance()
    .get('/categories/getAll', {
      params,
    })
    .then((response) => response.data);
}

export function getParentCategories(): Promise<Oked[]> {
  return instance()
    .get('/categories/getParent')
    .then((response) => response.data);
}
